/// <amd-module name='SuiteCommerce.ItemRecSys.WidgetCct.Model'/>
define("SuiteCommerce.ItemRecSys.WidgetCct.Model", ["require", "exports", "jQuery", "underscore"], function (require, exports, $, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AjaxErrorHelper = void 0;
    var AjaxErrorHelper = /** @class */ (function () {
        function AjaxErrorHelper() {
            this.suppressedHandlers = [];
        }
        AjaxErrorHelper.createAndSuppress = function () {
            var instance = new AjaxErrorHelper();
            instance.suppressAjaxErrors();
            return instance;
        };
        AjaxErrorHelper.prototype.suppressAjaxErrors = function () {
            try { // We will suppress any errors as this is just "cosmetics" functionality
                // @ts-ignore TS2551: Property '_data' does not exist on type 'JQueryStatic'. Did you mean 'data'?
                var handlerObjects = $['_data'](document, "events")['ajaxError'];
                if (handlerObjects && handlerObjects.length > 0) {
                    var handlers = _(handlerObjects).pluck('handler');
                    jQuery(document).off('ajaxError');
                    this.suppressedHandlers = handlers;
                }
            }
            catch (e) {
                console.log("ItemRecSysWidget: Could not suppress jQuery Ajax error handlers.", e);
            }
        };
        ;
        AjaxErrorHelper.prototype.restoreAjaxErrorHandling = function () {
            try { // We will suppress any errors as this is just "cosmetics" functionality
                if (this.suppressedHandlers.length > 0) {
                    this.suppressedHandlers.forEach(function (handler) {
                        return jQuery(document).ajaxError(handler);
                    });
                }
            }
            catch (e) {
                console.log("ItemRecSysWidget: Could not restore jQuery Ajax error handlers.", e);
            }
        };
        ;
        return AjaxErrorHelper;
    }());
    exports.AjaxErrorHelper = AjaxErrorHelper;
});
